/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { API_CONFIG, getEnv } from '../config/api'
import { ApiResponse, ErrorData } from '../interfaces'
import { IClientData } from '../redux/clientData'

const env = getEnv()

const {
  sendTo: { url: sendToURL, token },
} = API_CONFIG[env]

const fetchClientDataFromMiddleware = async (
  userId: string,
  sessionToken: string,
  middleware: AxiosRequestConfig
): Promise<ApiResponse<IClientData | ErrorData>> => {
  const url = `${middleware.url}/${sessionToken}`

  try {
    const { data, status } = (await axios({
      ...middleware,
      url,
    })) as AxiosResponse<IClientData>

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const fetchClientDataFromBSNG = async (
  userId: string,
  sessionToken: string
): Promise<ApiResponse<IClientData | ErrorData>> => {
  const payload = {
    userId,
    sessionToken,
  }

  try {
    const { data, status } = await axios.post<IClientData>(sendToURL, payload, {
      headers: {
        'x-api-key': token,
      },
    })

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const fetchClientData = async (
  userId: string,
  sessionToken: string,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<IClientData | ErrorData>> => {
  if (middleware) {
    const response = await fetchClientDataFromMiddleware(userId, sessionToken, middleware)
    return response
  }

  const response = await fetchClientDataFromBSNG(userId, sessionToken)
  return response
}

export default fetchClientData
